/** Set to false to hide Deal of the Day on the homepage (chip + product section). */
export const DEALS_OF_THE_DAY_HOME_ENABLED = true;

/** Default homepage layout when REACT_APP_HOMEPAGE_VARIANT is unset. */
export const HOMEPAGE_VARIANT_DEFAULT = 'engaging';

/**
 * Resolve homepage variant: env var → ?homepage= query → default.
 * @returns {'classic' | 'engaging'}
 */
export function resolveHomepageVariant() {
  const env = process.env.REACT_APP_HOMEPAGE_VARIANT;
  if (env === 'classic' || env === 'engaging') {
    return env;
  }

  if (typeof window !== 'undefined') {
    const queryVariant = new URLSearchParams(window.location.search).get('homepage');
    if (queryVariant === 'classic' || queryVariant === 'engaging') {
      return queryVariant;
    }
  }

  return HOMEPAGE_VARIANT_DEFAULT;
}

/** @returns {boolean} Whether the homepage shows the Deal of the Day chip and section. */
export function isDealsOfTheDayHomeEnabled() {
  return DEALS_OF_THE_DAY_HOME_ENABLED;
}

export const LANDING_SEO_TITLE = 'Compare products from online shops in Malta';

export const LANDING_ENGAGING_SEO_TITLE = 'Find the best prices from local stores in Malta';

export const LANDING_ENGAGING_SEARCH_PLACEHOLDER =
  'Search e.g. iPhone, Nike trainers, desk…';
